/**
 * Single source of truth for which component types may live under which parents
 * after a drag-reorder (matches builder add-element rules where applicable).
 */

const NAV_ONLY_PARENT_TYPES = new Set(["nav", "navigation-container"]);

/**
 * Whether `childType` may sit under `parentType` after a reorder (same-parent or reparent).
 */
export function isChildAllowedUnderParent(
  parentType: string | undefined,
  childType: string | undefined
): boolean {
  if (!parentType || !childType) {
    return false;
  }
  if (NAV_ONLY_PARENT_TYPES.has(parentType)) {
    return childType === "nav-item";
  }
  return true;
}
